import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaRocket,
  FaCogs,
  FaExpandArrowsAlt,
  FaLock,
  FaChartBar,
  FaUsers,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ScalableEcommerceSolutionsInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Scalable E-commerce Solutions in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Grow Without Limits</Subheading>}
        heading={
          <Heading>
            Scalable E-commerce <span tw="text-primary-500">Solutions</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we deliver scalable e-commerce solutions in **Bur
            Dubai**, designed to grow with your business. From startups to
            enterprises, our platforms adapt to your needs with seamless
            performance and flexibility.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // E-commerce dashboard
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Business growth chart
          "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Dubai skyline
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Scale Your Business"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Scalable E-commerce in Bur Dubai"
        description="Our solutions are built for growth and efficiency."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Deployment",
            description: "Launch quickly with scalable infrastructure.",
          },
          {
            icon: <FaCogs color="#ff5464" size={40} />,
            title: "Customizable Features",
            description: "Tailored solutions to fit your business.",
          },
          {
            icon: <FaExpandArrowsAlt color="#ff5464" size={40} />,
            title: "Scalable Architecture",
            description: "Grow without performance bottlenecks.",
          },
          {
            icon: <FaLock color="#ff5464" size={40} />,
            title: "Secure Systems",
            description: "Protect your data and transactions.",
          },
          {
            icon: <FaChartBar color="#ff5464" size={40} />,
            title: "Analytics Integration",
            description: "Track performance and optimize growth.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Customer Focused",
            description: "Designed for exceptional user experience.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Scalable E-commerce Process"
        description={
          <Description>
            We build your scalable e-commerce platform with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Define your scalability goals.</li>
              <li>Design: Craft a flexible, user-friendly interface.</li>
              <li>Development: Build with scalable technology.</li>
              <li>Integration: Add payment and analytics tools.</li>
              <li>Testing: Ensure performance under load.</li>
              <li>Support: Provide ongoing scalability upgrades.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Team planning
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Business strategy
          "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Dubai business district
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Explore Solutions"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="E-commerce Growth in Bur Dubai"
        description="Our scalable solutions drive real results."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Rapid Expansion",
            description: "Scaled a store to 1,000+ orders in 6 months.",
          },
          {
            icon: <FaChartBar color="#ff5464" size={40} />,
            title: "Performance Boost",
            description: "Improved load times by 40% during peak traffic.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Happy Clients",
            description: "95% satisfaction from Bur Dubai businesses.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Scale?</Subheading>}
        heading="Scalable E-commerce in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for scalable e-commerce solutions in Bur
            Dubai. Build a platform that grows with your vision—get started
            today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Mobile e-commerce
          "https://images.unsplash.com/photo-1526458179558-6c36b2399722?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Developer coding
          "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Dubai modern architecture
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
